import { Component, Input, OnChanges } from '@angular/core';
import Order from '../../../smoothr-web-app-core/models/Order';
import { NavigationService } from 'src/app/services/navigation.service';
import { RepositoryService } from 'src/smoothr-web-app-core/services/repository/repository.service';
import { AskToCreateAccountModalComponent } from '../ask-to-create-account-modal/ask-to-create-account-modal.component';
import { ModalController } from '@ionic/angular';
import { SignInModalComponent } from '../sign-in-modal/sign-in-modal.component';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-to-order-button',
	templateUrl: './to-order-button.component.html',
	styleUrls: ['to-order-button.component.scss'],
})
export class ToOrderButtonComponent implements OnChanges {
	@Input() order: Order;

	name = this.route.snapshot.queryParamMap.get('name');
	orderArticlesNumber = 0;

	constructor(
		private navigationService: NavigationService,
		private repositoryService: RepositoryService,
		private modalCtrl: ModalController,
		protected repository: RepositoryService,
		private route: ActivatedRoute
	) {}

	ngOnChanges(): void {
		this.orderArticlesNumber = this.order.orderedArticles.reduce((acc, item) => (acc += item.quantity), 0);
	}

	async goToOrder() {
		// if (this.repositoryService?.customer?.isAnonymous && !this.order.preorder.email) {
		// 	const result = await AskToCreateAccountModalComponent.show(this.modalCtrl);
		// 	if (result === 'sign_in') {
		// 		this.signIn();
		// 		return;
		// 	}
		// 	if (typeof result === 'string' && result.length > 0) {
		// 		this.order.preorder.email = result;
		// 		this.repository.onOrderChange(this.order);
		// 	}
		// 	await this.navigationService.order();
		// } else {
		await this.navigationService.order();
		// }
	}

	async signIn() {
		try {
			await this.modalCtrl.dismiss();
		} catch (e) {}
		const result = await SignInModalComponent.show(this.modalCtrl);
	}
}
